import { useTranslation } from 'react-i18next';

import { downloadString } from 'utils'
import moment from 'moment'

const toNumber = (num) => {
  if (num !== null && !isNaN(num)) {
    return num
  }
  return '-'
}

const SITE_EQUIPMENT_FIELDS = [
  { header: 'supervision.tables.nb_switch',      key: 'nb_switches' },
  { header: 'supervision.tables.nb_esl',         key: 'nb_esls' },
  { header: 'supervision.tables.nb_firewall',    key: 'nb_firewalls' },
  { header: 'supervision.tables.nb_inverter',    key: 'nb_inverters' },
  { header: 'supervision.tables.nb_cctv_camera', key: 'nb_cctv_cameras' },
  { header: 'supervision.tables.nb_cctv_server', key: 'nb_cctv_servers' },
]


const useExport = ({sites}) => {
  const { t } = useTranslation();

  const create = async () => {
    const sitesSelected = sites.filter(({equipment}) => Boolean(equipment))

    const baseHeaders = [
      'supervision.tables.status_col',
      'supervision.tables.site_col',
      'supervision.tables.nb_ap',
      'supervision.tables.nb_equipment',
      'supervision.tables.nb_lines',
    ]

    const extraFields = SITE_EQUIPMENT_FIELDS.filter(({ key }) =>
      sitesSelected.some(site => (site.equipment?.[key] || 0) > 0)
    )

    const translatedHeaders = [
      ...baseHeaders,
      ...extraFields.map(f => f.header),
    ].map(header => t(header).toUpperCase())

    const data = sitesSelected
      .map(site => {
        return [
          ['up', 'notReferenced'].includes(
            site.equipment?.available_level,
          )
            ? 'Ok'
            : 'Down',
          site.name?.toString() || '-',
          toNumber(site.equipment?.nb_accesspoints?.toString()),
          toNumber(site.equipment?.nb_active_users?.toString()),
          toNumber(site.equipment?.nb_lines?.toString() || '0'),
          ...extraFields.map(({ key }) => toNumber(site.equipment?.[key]?.toString())),
        ].join(',')
      })
      .join('\r\n')
    const dataString = `data:text/csv;charset=utf-8,${translatedHeaders.join(',')}\r\n${data}`
    await downloadString({ dataString, fileName: `sites_${moment().format('YYYY/MM/DD HH:mm')}.csv` })
  }

  return create
}

export default useExport